// extracted by mini-css-extract-plugin
export default {"reference":"styles_reference__4pmEk","name":"styles_name__mZMFY"};